// Canonical support email. Do not replace.
// This is the single source of truth for the platform contact email.
// All UI, PDF templates, and exports must import from here.
export const SUPPORT_EMAIL = 'info@yourbrandvalue.com';
